import React from 'react'
import {Router, Routes, Route} from '@startlibs/components'
import {AdminRoutes} from './admin/AdminRoutes'
import {ExpertRoutes} from './expert/ExpertRoutes'
import {LandingPage} from './pages/LandingPage'
import {MedicalReleaseDocument} from './pages/MedicalReleaseDocument'
import {PatientRoutes} from './patient/PatientRoutes'
import {ProviderUploadRecords} from './pages/ProviderUploadRecords'
import {IconsPage} from './pages/IconsPage'
import {ShareRoutes} from './share/ShareRoutes'
import {SSONotFoundError} from './pages/errors/SSONotFoundError'
import {Redirect} from './components/Redirect'

const Identity = React.forwardRef(({children}, ref) => <React.Fragment>{children}
  <div ref={ref}/>
</React.Fragment>)
Identity.displayName = 'Identity'

export const AppRoutes = ({isPdfServer}) => <Router>
  <Routes component={Identity}>
    <Route path="/share/:jwt" element={<ShareRoutes login/>}/>
    <Route path="/shared/:jwt" element={<ShareRoutes/>}/>
    <Route path="/expert*" element={<ExpertRoutes/>}/>
    <Route path="/expert/*" element={<ExpertRoutes/>}/>
    <Route path="/admin*" element={<AdminRoutes />}/>
    <Route path="/admin/*" element={<AdminRoutes />}/>
    <Route path="/patient*" element={<PatientRoutes />}/>
    <Route path="/patient/*" element={<PatientRoutes />}/>
    <Route path="/nurse*" element={<PatientRoutes isNurse/>}/>
    <Route path="/nurse/*" element={<PatientRoutes isNurse/>}/>
    <Route path="/refphysician*" element={<PatientRoutes isRefPhysician />}/>
    <Route path="/refphysician/*" element={<PatientRoutes isRefPhysician />}/>
    <Route path="/access*" element={<PatientRoutes />}/>
    <Route path="/access/*" element={<PatientRoutes />}/>
    <Route path="/access-case" element={<PatientRoutes />}/>
    <Route path="/invalid-login" element={<SSONotFoundError />}/>
    <Route path="/provider/medicalRelease/:code" element={<MedicalReleaseDocument/>}/>
    <Route path="/uploadMedicalRecords/:code" element={<ProviderUploadRecords/>}/>
    <Route path="/icons" element={<IconsPage />}/>
    <Route path="/" element={<LandingPage />}/>
    {!isPdfServer && <Route path="*" element={<Redirect to="/" noThrow/>}/>}
  </Routes>
</Router>
